import styled from 'styled-components'

export const Container = styled.div`
    bottom: 0px;
    top: 52px;
    position: absolute;
    padding-left: 20px;
    height: 58px;
`
